<template>
    <v-container grid-list-md fluid>
        <AccountingLogBank
            v-if="showAccountingLogBank"
            v-model="type"
            :documentTypes="types"
        >
        </AccountingLogBank>
        <AccountingLogDocument
            v-else
            v-model="type"
            :documentTypes="documentTypes"
            :logTypes="types"
        >
        </AccountingLogDocument>
    </v-container>
</template>

<script lang="ts">
import AccountingLogDocument from "./AccountingLogDocument.vue";
import AccountingLogBank from "./AccountingLogBank.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        AccountingLogDocument,
        AccountingLogBank,
    },
})
export class AccountingLogPage extends Vue {
    get documentTypes() {
        return [
            "SALES_INVOICE",
            "SALES_INVOICE_AUTO",
            "ZTILL_RECEIPT",
            "PURCHASE_INVOICE",
            "CURRENT_ACCOUNT",
            "OPERATOR_ACCOUNT",
            "PAY_SLIP",
            "MISCELLANEOUS_OPERATION",
            "CARRY_FORWARD",
            "WITH_DELTA",
            "EXPENSE_REPORT",
            "WITHOUT_INVOICE",
            "VAT",
            "BANK_CHARGE",
            "WAITING_CASHING",
            "SEPA",
            "SUBSCRIPTION",
            "LOAN",
            "LEASING",
            "SUBSCRIPTION_ACCOUNTING",
            "LOAN_ACCOUNTING",
            "LEASING_ACCOUNTING",
        ];
    }

    /**
     * Log type.
     * Must be undefined by default.
     * The child components will update it.
     */
    type: string | undefined;

    get showAccountingLogBank(): boolean {
        return this.type?.startsWith('BANK_TRANSACTION');
    }

    get types() {
        const types = ["ALL"];
        types.push(...this.documentTypes);
        types.push("BANK_TRANSACTION");
        return types;
    }
}

export default toNative(AccountingLogPage);
</script>
